<template>
  <div class="inspection--companyheader">
    <img
      v-if="company.logo"
      id="company-logo"
      class="company-logo"
      :src="company.logo" />

    <p class="company-name">{{company.name}}</p>
    <p class="company-address1">{{company.address1}}</p>
    <p class="company-address2">{{company.address2}}</p>
    <p class="company-city">{{company.city}}, {{company.state}} {{company.postalCode}}</p>
    <p class="company-email">{{company.email}}</p>
    <p class="company-primaryPhone">{{company.phone}}</p>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  text-transform: uppercase;
}

.company-logo {
  margin: 0 0 20px;
  max-height: 95px;
  max-width: 155px;
}

p {
  font-size: 1.15rem;
  line-height: 1.6;
  margin: 0;
}

@media all and (max-width: 960px) {
  .company-address {
    margin-bottom: 20px;
  }
}
</style>
